module.exports = __webpack_public_path__ + "static/media/americanFlagPatch01.51ffb479.jpeg";